import { FarawayWalletsProvider } from '@farawaygg/faraway-wallets-provider';

var u = Object.defineProperty;
var w = (l, e, t) => e in l ? u(l, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: t
}) : l[e] = t;
var d = (l, e, t) => (w(l, typeof e != "symbol" ? e + "" : e, t), t);
const E = {
  METHOD_NOT_IMPLEMENTED: {
    code: -1,
    type: "internal",
    message: "Method is not implemented"
  },
  REQUIRE_WALLETS_PROVIDER: {
    code: 1,
    type: "library",
    message: "FarawayWalletsProvider does not exist. Connect the library"
  },
  NOT_WORKING_ON_MOBILE: {
    code: 2,
    type: "device",
    message: "Does not work on mobile device"
  },
  MODAL_CANNOT_BE_OPENED: {
    code: 3,
    type: "internal",
    message: "Modal cannot be opened"
  },
  INVALID_OPEN_TYPE: {
    code: 4,
    type: "internal",
    message: "Invalid open type"
  },
  CHECKOUT_WAS_NOT_OPENED: {
    code: 5,
    type: "internal",
    message: "FarawayCheckout was not opened"
  },
  TAB_WAS_BLOCKED: {
    code: 6,
    type: "internal",
    message: "Tab was blocked"
  },
  POPUP_WAS_BLOCKED: {
    code: 7,
    type: "internal",
    message: "Popup was blocked"
  }
};
class r extends Error {
  constructor(t, s) {
    const {
      code: o,
      message: i,
      type: n
    } = E[t];
    super(i, s);
    d(this, "code");
    d(this, "type");
    this.code = o, this.type = n;
  }
}
const O = 1e3;
function f(l, e) {
  const t = () => {
    l.closed && (o(), e());
  };
  let s = !1;
  const o = () => {
      s || (s = !0, clearInterval(i), window.removeEventListener("focus", t));
    },
    i = setInterval(t, O);
  return window.addEventListener("focus", t), {
    detach: o
  };
}
const c = {
  width: "auto",
  height: "auto",
  borderRadius: 32
};
let _ = class {
  /** @ignore */
  constructor(e = {}, t) {
    /** @ignore */
    d(this, "opened", null);
    /** @ignore */
    d(this, "openedProvider", null);
    /** @ignore */
    d(this, "openedType", null);
    d(this, "beforeUnloadCallback", () => {
      this.close();
    });
    d(this, "detachOpenedOnClose", null);
    /** @ignore */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    d(this, "listeners", {});
    /** @ignore */
    d(this, "createModal", (e, t) => {
      const s = document.createElement("div");
      let o = 0;
      s.id = "faraway-checkout", s.style.position = "fixed", s.style.top = "0", s.style.left = "0", s.style.width = "100vw", s.style.height = "100vh", s.style.zIndex = "9999", s.style.backgroundColor = "rgba(0,0,0,0.65)", s.style.display = "flex", s.style.justifyContent = "center", s.style.alignItems = "center";
      const i = document.createElement("div");
      i.style.display = "grid", i.style.backgroundColor = "white", i.style.borderRadius = `${t.borderRadius}px`, i.style.overflow = "hidden", i.style.width = "100%", i.style.maxWidth = t.width === "auto" ? "900px" : `${t.width}px`, s.append(i);
      const n = document.createElement("iframe");
      return n.allow = "payment", n.src = e, n.width = "100%", n.height = t.height === "auto" ? "800px" : `${t.height}px`, n.style.border = "none", n.style.outline = "none", (t.width === "auto" || t.height === "auto") && (n.style.display = "none"), i.append(n), document.body.append(s), this.log("debug", "Modal was created", {
        wrapper: s,
        dialog: i,
        iframe: n
      }), this.on("FARAWAY_CHECKOUT_INITIAL_SIZE", a => {
        if (n.style.display = "initial", t.width === "auto" && (i.style.maxWidth = a.width + "px"), t.height === "auto") {
          n.height = a.height + "px";
          const h = window.innerHeight;
          if (a.height > o && h < a.height) {
            o = a.height;
            const p = h / a.height;
            i.style.transform = `scale(${p})`;
          }
        }
      }), n.contentWindow;
    });
    d(this, "logStyles", {
      debug: "color:#666aff;font-weight:bold;",
      error: "color:#fa2a2a;font-weight:bold;"
    });
    d(this, "whitelistDomains", ["https://sandbox.coinflow.cash", "https://coinflow.cash", "https://auth.turnkey.com"]);
    this.theme = e, this.logLevel = t, this.log("debug", "Create instance", e), this.on("FARAWAY_CHECKOUT_INIT", () => {
      this.setTheme(this.theme);
    }), this.on("FARAWAY_CHECKOUT_CLOSE", () => {
      this.close();
    }), window.addEventListener("message", s => {
      var o, i, n;
      this.whitelistEmitter(s), (i = (o = s.data) == null ? void 0 : o.method) != null && i.startsWith("FARAWAY_CHECKOUT") && (this.log("debug", `Received Message '${s.data.method}'`, s.data.data), (n = this.listeners[s.data.method]) == null || n.forEach(a => a(s.data.data)));
    });
  }
  /**
   * Open checkout page
   * @param url - checkout url
   * @param type - how needs to open the checkout page. Possible values are 'popup' | 'iframe' | 'blank' | 'modal'
   *
   * @example
   * ```ts
   * const checkout = new FarawayCheckout();
   *
   * // Open checkout in blank
   * checkout.open('<URL>', 'blank');
   *
   * // Open checkout in iframe
   * FarawayWalletsProvider library must be included
   * checkout.open('<URL>', 'iframe');
   *
   * // Open checkout in standart browser popup
   * checkout.open('<URL>', 'popup', { width: 780, height: 800 });
   *
   * // Open checkout in modal
   * // FarawayWalletsProvider library must be included
   * checkout.open('<URL>', 'modal', { width: 780, height: 800 });
   * ```
   */
  open(e, t, s = {}) {
    this.log("debug", "Open", {
      url: e,
      type: t,
      options: s
    }), this.close(), this.openedType = t, s.customFields && this.once("FARAWAY_CHECKOUT_INIT", () => this.setCustomFields(s.customFields || {}));
    try {
      if (t === "blank") {
        if (this.opened = window.open(e, "_blank"), !this.opened) throw new r("TAB_WAS_BLOCKED");
        this.setupOpenedWindow(this.opened);
        return;
      }
      if (t === "popup") {
        if (this.openedProvider = this.createWalletsProviderInstance(), !this.openedProvider) throw new r("REQUIRE_WALLETS_PROVIDER");
        if (this.openedProvider.deviceDetector.mobile) throw new r("NOT_WORKING_ON_MOBILE");
        const o = {
            ...c,
            ...s
          },
          i = [`width=${o.width}`, `height=${o.height}`, "popup=1", "menubar=0", "location=0", "toolbar=0", "status=0"];
        if (o.height !== "auto" && i.push(`top=${Math.max((window.screen.availHeight - o.height) / 2, 0)}`), o.width !== "auto" && i.push(`left=${Math.max((window.screen.availWidth - o.width) / 2, 0)}`), this.opened = window.open(e, void 0, i.join(",")), !this.opened) throw new r("POPUP_WAS_BLOCKED");
        const n = this.opened;
        this.openedProvider.setMessagingTarget ? this.openedProvider.setMessagingTarget(n) : this.openedProvider.wallets.forEach(a => a.initMessaging(n)), this.setupOpenedWindow(n);
        return;
      }
      if (t === "iframe") throw new r("METHOD_NOT_IMPLEMENTED");
      if (t === "modal") {
        if (this.openedProvider = this.createWalletsProviderInstance(), !this.openedProvider) throw new r("MODAL_CANNOT_BE_OPENED");
        if (this.openedProvider.deviceDetector.mobile) throw new r("NOT_WORKING_ON_MOBILE");
        const o = {
            ...c,
            ...s
          },
          i = this.createModal(e, o);
        if (!i) throw new r("MODAL_CANNOT_BE_OPENED");
        document.body.style.overflow = "hidden", this.openedProvider.setMessagingTarget ? this.openedProvider.setMessagingTarget(i) : this.openedProvider.wallets.forEach(n => n.initMessaging(i)), this.opened = i;
        return;
      }
      throw new r("INVALID_OPEN_TYPE");
    } catch (o) {
      throw this.close(), o;
    }
  }
  setupOpenedWindow(e) {
    window.addEventListener("beforeunload", this.beforeUnloadCallback);
    const {
      detach: t
    } = f(e, () => {
      this.close();
    });
    this.detachOpenedOnClose = t;
  }
  /**
   * Close opened checkout page
   */
  close() {
    var e, t, s, o, i, n;
    if (this.log("debug", "close", {
      type: this.openedType
    }), this.openedType !== null) switch (this.openedType) {
      case "popup":
      case "blank":
        (e = this.openedProvider) == null || e.destroy(), this.openedProvider = null, (t = this.detachOpenedOnClose) == null || t.call(this), this.detachOpenedOnClose = null, (s = this.opened) == null || s.close(), this.opened = null, this.openedType = null, window.removeEventListener("beforeunload", this.beforeUnloadCallback), this.emulateMessage("FARAWAY_CHECKOUT_CLOSE", {
          type: "lib"
        });
        return;
      case "iframe":
        (o = this.openedProvider) == null || o.destroy(), this.openedProvider = null, this.opened = null, this.openedType = null;
        return;
      case "modal":
        document.body.style.overflow = "", (i = this.openedProvider) == null || i.destroy(), this.openedProvider = null, (n = document.getElementById("faraway-checkout")) == null || n.remove(), this.opened = null, this.openedType = null;
        return;
      default:
        throw new r("INVALID_OPEN_TYPE");
    }
  }
  /**
   * Change theme of opened checkout page
   * @param theme Theme object
   */
  setTheme(e) {
    if (this.log("debug", "setTheme", e), !this.opened) throw new r("CHECKOUT_WAS_NOT_OPENED");
    this.opened.postMessage({
      method: "FARAWAY_CHECKOUT_SET_THEME",
      data: e
    }, "*");
  }
  /**
   * Set custom fields for checkout page
   * @param fields CustomFields object
   */
  setCustomFields(e) {
    if (this.log("debug", "setCustomFields", e), !this.opened) throw new r("CHECKOUT_WAS_NOT_OPENED");
    this.opened.postMessage({
      method: "FARAWAY_CHECKOUT_CUSTOM_FIELDS",
      data: e
    }, "*");
  }
  /**
   * Start listening the event from checkout page
   */
  on(e, t) {
    var s, o;
    this.listeners[e] || (this.listeners[e] = []), (s = this.listeners[e]) == null || s.push(t), this.log("debug", "Start listening", {
      method: e,
      listeners: (o = this.listeners[e]) == null ? void 0 : o.length
    });
  }
  /**
   * Listening the event from checkout page only once
   */
  once(e, t) {
    const s = o => {
      t(o), this.off(e, s);
    };
    this.on(e, s);
  }
  /**
   * Stop listening the event from checkout page
   */
  off(e, t) {
    var o, i, n, a;
    if (!((o = this.listeners[e]) != null && o.length)) return;
    const s = ((i = this.listeners[e]) == null ? void 0 : i.indexOf(t)) ?? -1;
    s >= 0 && ((n = this.listeners[e]) == null || n.splice(s, 1)), this.log("debug", "Stop listening", {
      method: e,
      listeners: (a = this.listeners[e]) == null ? void 0 : a.length
    });
  }
  emulateMessage(e, t) {
    window.postMessage({
      method: e,
      data: t
    }, "*");
  }
  log(e, ...t) {
    this.logLevel && (this.logLevel === "error" && this.logLevel !== e || console.log("%c[faraway-checkout-lib]:%c", this.logStyles[e], "color:initial", ...t));
  }
  whitelistEmitter(e) {
    var t;
    this.whitelistDomains.includes(e.origin) && ((t = this.opened) == null || t.postMessage(e.data, "*"));
  }
};
class C extends _ {
  createWalletsProviderInstance() {
    return new FarawayWalletsProvider();
  }
}

export { C as FarawayCheckout };
//# sourceMappingURL=faraway-checkout.es-d9425fda.js.map
